import { SortDirectionType } from '@rio-cloud/rio-uikit/utils/SortUtils';
import { useState } from 'react';

import { useLazyFetchThreadsQuery } from '@/services/threadApi/threadApi';
import { mapFetchThreadsRequestParams } from '@/services/threadApi/utils/mapFetchThreadsRequestParams';

/**
 * Custom hook for thread search functionality
 * @param userId - Current user identifier
 * @param {SortDirectionType}sortOrder - Current sort order
 * @param {boolean} favoriteOnly - Filter to favorites only
 * @returns searchValue and handleSearch function
 */
export const useThreadSearch = (userId: string, sortOrder: SortDirectionType, onlyFavorites: boolean) => {
  const [searchValue, setSearchValue] = useState('');
  const [fetchThreads] = useLazyFetchThreadsQuery();

  const handleSearch = async (searchValue: string) => {
    setSearchValue(searchValue);
    await fetchThreads(
      mapFetchThreadsRequestParams({
        userId,
        sortOrder,
        search: searchValue,
        onlyFavorites,
      }),
    );
  };

  return { searchValue, handleSearch };
};
